// Add-to-cart for the bundle upsell blocks in main-product-v2.
// Kept separate from the section's <cart-form> so it only adds the bundle,
// never the main product. cart-487.js's themeStore wraps fetch, so this
// request refreshes the cart drawer the same way the main add-to-cart does.
// While the request runs, the element gets the `loading` class, which hides
// the label and shows the spinner (see snippets/bundle-upsell.liquid).
class BundleUpsellAtc extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.error = this.querySelector('[data-error]');

    if (!this.button || this.button.disabled) return;

    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.button && this.onClick) {
      this.button.removeEventListener('click', this.onClick);
    }
  }

  async onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.classList.contains('loading')) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const payload = {
      items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
    };
    // Ask for the drawer's markup too, otherwise the drawer opens with stale contents.
    if (cartDrawer && cartDrawer.dataset.sectionId) {
      payload.sections = [cartDrawer.dataset.sectionId];
    }

    this.showError('');
    this.setLoading(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok) {
        this.showError(data.description || data.message || this.dataset.errorText);
        return;
      }

      if (cartDrawer && !location.pathname.includes('/cart')) {
        cartDrawer.open();
      } else {
        window.location.href = `${window.Shopify.routes.root}cart`;
      }
    } catch (error) {
      console.error('Bundle upsell: failed to add to cart', error);
      this.showError(this.dataset.errorText);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.classList.toggle('loading', isLoading);
    this.button.setAttribute('aria-busy', String(isLoading));
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message || '';
    this.error.classList.toggle('hidden', !message);
  }
}

if (!customElements.get('bundle-upsell-atc')) {
  customElements.define('bundle-upsell-atc', BundleUpsellAtc);
}
